import { render, staticRenderFns } from "./BecomeCorporateKeyPartner.vue?vue&type=template&id=16c51f1e&"
import script from "./BecomeCorporateKeyPartner.vue?vue&type=script&lang=js&"
export * from "./BecomeCorporateKeyPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports